module.exports = __webpack_public_path__ + "media/recipes/37-ce517987.png";